var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray"},[_c('my-table',{attrs:{"config":_vm.tableConfig}}),_vm._v(" "),_c('page-btns',{attrs:{"obj":_vm.btnConfig}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }